import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=5ae06e76&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview.vue?vue&type=style&index=0&id=5ae06e76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports